import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./context/AuthContext";
import { AdminAuthProvider } from './Admin/Context/adminAuthContext';
import 'mapbox-gl/dist/mapbox-gl.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
    <AdminAuthProvider>
    <App />
  </AdminAuthProvider>
  </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
